import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgQuestionAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#003099" />
      <path
        fill="white"
        fillRule="evenodd"
        d="M14.7318 16.9668L14.7306 16.9742L14.7298 16.9817C14.6989 17.255 14.6839 17.5509 14.6839 17.8688V18.8358H17.2724V18.1117C17.2724 17.9202 17.2854 17.7472 17.3103 17.5918C17.3481 17.4276 17.4038 17.2704 17.4776 17.1198C17.5676 16.9496 17.6853 16.7755 17.8324 16.5976L17.8402 16.5874C17.9863 16.396 18.1766 16.1919 18.4141 15.9751L18.4188 15.9706C18.732 15.6731 19.0375 15.3594 19.3352 15.0295L19.3404 15.0234C19.6428 14.6715 19.9086 14.3098 20.1374 13.9381C20.3847 13.5438 20.5788 13.131 20.7188 12.7C20.8617 12.2601 20.9322 11.7964 20.9322 11.3107C20.9322 10.612 20.8171 9.96437 20.5821 9.37193C20.3624 8.76539 20.0318 8.24031 19.5896 7.80145C19.1616 7.34598 18.6407 6.99753 18.0324 6.75492C17.4176 6.49349 16.7385 6.36572 16 6.36572C15.2616 6.36572 14.5825 6.49349 13.9677 6.75492C13.3583 6.99793 12.8306 7.34665 12.3886 7.80149C11.9609 8.24051 11.6308 8.7649 11.3969 9.36996L11.3953 9.37406C11.1755 9.96586 11.0679 10.6126 11.0679 11.3107V11.6407H13.7002V11.3107C13.7002 10.6049 13.91 10.0494 14.313 9.61674C14.7061 9.19462 15.2543 8.96886 16 8.96886C16.7458 8.96886 17.2939 9.19462 17.6871 9.61674C18.0901 10.0494 18.2999 10.6049 18.2999 11.3107C18.2999 11.7741 18.1618 12.2118 17.8754 12.6302C17.5719 13.0736 17.1223 13.5818 16.5186 14.1554C16.1318 14.5182 15.8135 14.8533 15.5672 15.1604L15.561 15.1687C15.3311 15.4744 15.1435 15.7764 15.0009 16.0748L14.998 16.0814C14.8693 16.3667 14.7803 16.662 14.7318 16.9668ZM13.8001 23.4339C13.8001 22.2189 14.7851 21.2339 16.0001 21.2339C17.2151 21.2339 18.2001 22.2189 18.2001 23.4339C18.2001 24.6489 17.2151 25.6339 16.0001 25.6339C14.7851 25.6339 13.8001 24.6489 13.8001 23.4339Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgQuestionAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
